import { useSpinner } from '@webkit/components/typescript/SpinnerContext';
import { useEffect } from 'react';

function Spinner() {

  const { loading } = useSpinner();
  useEffect(() => {
    if (loading) {   
      window.scrollTo({ top: 0, behavior: "auto" });
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [loading]);

  if (!loading) return null;

  return (
    <div id="spinner">
      <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  );
};

export default Spinner;